// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__JS9I0","desabilitar":"OptionSelect_desabilitar__1zr7w","focado":"OptionSelect_focado__1B6WL","novo":"OptionSelect_novo__1B8Ei"};